import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { accountApi } from "../../lib/api/account.js";
import { useAuth } from "../../lib/auth-context.js";
import "./Onboarding.css";

const HANDLE_RE = /^[a-z0-9_]{3,30}$/;

export function Onboarding() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [handle, setHandle] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const valid = HANDLE_RE.test(handle);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!valid) {
      setError("3–30 characters: lowercase letters, numbers, and underscores.");
      return;
    }
    setBusy(true);
    setError(null);
    const res = await accountApi.setHandle(handle);
    if (res.success) {
      await refresh();
      navigate("/app", { replace: true });
    } else {
      setBusy(false);
      setError(res.error ?? "Couldn't save your handle. Try another.");
    }
  }

  return (
    <main className="onb">
      <form className="onb__card" onSubmit={onSubmit}>
        <img src="/tatu.svg" alt="" aria-hidden="true" width={40} height={40} />
        <h1 className="onb__title">Welcome{user?.name ? `, ${user.name}` : ""} 🦫</h1>
        <p className="onb__sub">Pick a handle so your people can find you.</p>

        <label className="onb__field">
          <span className="onb__at">@</span>
          <input
            className="onb__input"
            value={handle}
            onChange={(e) => setHandle(e.target.value.toLowerCase().replace(/\s/g, ""))}
            placeholder="yourname"
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="off"
            aria-label="handle"
            maxLength={30}
          />
        </label>
        {error && (
          <p className="onb__error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="btn btn-primary" disabled={!valid || busy}>
          {busy ? "Saving…" : "Continue"}
        </button>
      </form>
    </main>
  );
}
